import { FolderShare } from "@zapier/client";

export function reduceSharesToAdd(toAdd: FolderShare[]) {
  return toAdd.reduce(
    (accumulator: number[][], { shareId, shareType }) => {
      if (shareType === "customuser") {
        accumulator[0].push(shareId);
      }
      if (shareType === "team") {
        accumulator[1].push(shareId);
      }
      if (shareType === "account") {
        accumulator[2].push(shareId);
      }
      return accumulator;
    },
    [[], [], []],
  );
}
